export class Icon {
  constructor(difference) {
    this.width = 56
    this.height = 56
    this.top = 10
    this.left = 10
    this.innerElement = "cxIcon"
    this.content = "图标"
    this.bgColor = "rgba(255, 255, 255, 0)"
    this.clipSize = "cover"
    this.repeatType = "no-repeat"
    this.alignType = "center center"
    this.color = "rgba(255,255,255,1)"
    this.bgType = "自定义"
    this.bgColorIsThemeColor = false
    this.boxShadowColor = []
    this.boxShadowH = []
    this.boxShadowV = []
    this.boxShadowBlur = []
    this.boxShadowSpread = []
    this.iconSrc = "611F4ADD5D8607EA"
    this.hoverIconSrc = "611F4ADD5D8607EA"
    this.clickIconSrc = "611F4ADD5D8607EA"
    this.iconSrcType = 0   //  0表示默认状态 使用iconSrc  1表示鼠标悬浮状态 使用hoverIconSrc    2表示鼠标点击状态 使用clickIconSrc
    this.iconType = "icon" // img,icon 图片和字体图标
    this.iconWidth = 40
    this.iconColorIsThemeColor = false
    this.iconColor = "#000000"
    this.opacity = 1
    this.background = []
    this.resInfo = {}
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
